export default __webpack_public_path__ + "static/media/user.f1ddcf46.svg";